import { render, staticRenderFns } from "./ProjectsFinished.vue?vue&type=template&id=55f77be6&"
import script from "./ProjectsFinished.vue?vue&type=script&lang=ts&"
export * from "./ProjectsFinished.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectsFinished.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout,VSpacer})
